<template>
    <div class="ma-4">
        <v-layout row wrap class="pa-2">
              <v-flex xs12>
                <v-btn fab x-small @click="$router.go(-1)">
                  <v-icon>navigate_before</v-icon>
                    
                  </v-btn>
              </v-flex>

              <v-flex xs12>
                <h1 class="text-center mb-5">Missing Staff Certifications Report</h1>
              </v-flex>
              
              <v-flex xs12 md3 class="pa-1">
                  <v-menu
                      ref="calendarMenu"
                      v-model="calendarMenu"
                      :close-on-content-click="false"
                      :return-value.sync="date"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                  >
                      <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="startDate"
                          label="Start Date"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :rules='requiredField'
                      ></v-text-field>
                      </template>
                      <v-date-picker
                      v-model="startDate"
                      no-title
                      scrollable
                      :rules='requiredField'

                      >
                      <v-spacer></v-spacer>
                      <v-btn
                          text
                          color="primary"
                          @click="calendarMenu = false"
                      >
                          Cancel
                      </v-btn>
                      <v-btn
                          text
                          color="primary"
                          @click="$refs.calendarMenu.save(date)"
                      >
                          OK
                      </v-btn>
                      </v-date-picker>
                  </v-menu>
                  
              </v-flex>

              <v-flex xs12 md3 class="pa-1">
                 <v-menu
                      ref="calendar2Menu"
                      v-model="calendar2Menu"
                      :close-on-content-click="false"
                      :return-value.sync="date"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                  >
                      <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="endDate"
                          label="End Date"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :rules='requiredField'

                      ></v-text-field>
                      </template>
                      <v-date-picker
                      v-model="endDate"
                      no-title
                      scrollable
                      :rules='requiredField'

                      >
                      <v-spacer></v-spacer>
                      <v-btn
                          text
                          color="primary"
                          @click="calendar2Menu = false"
                      >
                          Cancel
                      </v-btn>
                      <v-btn
                          text
                          color="primary"
                          @click="$refs.calendar2Menu.save(date)"
                      >
                          OK
                      </v-btn>
                      </v-date-picker>
                  </v-menu>
              </v-flex>

              <v-flex xs12 md3 class="pa-1 mb-2">
                <v-select 
                    label="Select Staff"
                    :items="employees"
                    item-text="Name"
                    item-value="_id"
                    v-model="StaffID"
                  ></v-select>
              </v-flex>

              <v-flex xs12 md3 class="mt-5 mb-5 pl-5">
                 <v-btn @click="expirationQuery()">Search</v-btn>
              </v-flex>

              <v-flex xs12 class="pa-2">
                  <v-data-table
                    :headers="headers"
                    :items="certs"
                    sort-by="Date"
                    sort-asc
                    class="elevation-1"
                    :loading="isLoading"
                    loading-text="Loading Missing Certifications"
                    items-per-page="100"

                  >
                  <template v-slot:item.select="{ item }">
                    <router-link :to="{name: 'MAR'}">
                      <v-btn
                        x-small
                        class="white--text"
                        color="#2b3990"
                        @click="getStaffID(item)"
                      >
                        view
                      </v-btn>
                      </router-link>          
                  </template>
                  </v-data-table>

              </v-flex>
          </v-layout>
    </div>
</template>
<script>
import axios from 'axios'
// import moment from 'moment'
// import Foot from '../components/Footer'

const url = require("../../client_config/config").url;

  export default {
    components: {
    },
    data: () => ({
    headers: [
      {
        text: 'Expiration Date',
        align: 'start',
        sortable: true,
        value: 'Expiration',
      },
      { text: "Certification Type", value: "CertificationType" },
      { text: "Certification", value: "Certification" },
      { text: "Notes", value: "Notes" },
      { text: "Date Issued", value: "DateIssued" },
      { text: "", value: "select" },

    ],
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    employees: [],
    certs: [],
    startDate: "",
    endDate: "",
    StaffID: '',
    calendarMenu: false,
    calednar2Menu: false,
    report: '',
    clientName: '',
    isLoading: false,
    requiredField: [
        v => !!v || 'This is required',
    ],
    }),

    computed: {
      
    },

    created() {
      this.getEmployees();
      
    },

    methods: {
      initialize() {
        this.tests = [];
      },

      getEmployees () {
        axios.get(`${url}/employees/Staff`).then(async res => {
          this.employees = res.data.employees;
          
        });      
      },
      close() {
        this.seditInfo = false;
        this.passdialog = false;
        this.chgimg = false;

      },
      

      expirationQuery() {
        this.certs = []
        this.isLoading = true
        if(this.StaffID==""){
          axios.get(`${url}/staffCertifications/${this.startDate}/${this.endDate}`).then(res => {
          this.certs = res.data.staffCerts
          this.isLoading = false;
          })
        }
        axios.get(`${url}/staffCertifications/${this.StaffID}/${this.startDate}/${this.endDate}`).then(res => {
          this.certs = res.data.staffCerts
          this.isLoading = false;
        })
      },

      getStaffID(item) {
      this.staff = item.EmployeeID;
      window.localStorage.setItem('staffId', this.staff)
      console.log(this.staff)
    },
    }
  }
</script>
<style>
@media only screen and (max-width: 480px) {

}
</style>